class PartialPaymentRequest {
  PartialPaymentRequestURL() {
    return process.env.REACT_APP_BASEURL + "PartialPayment";
  }


}

export const { PartialPaymentRequestURL } = new PartialPaymentRequest();